import {Column, Entity, PrimaryColumn} from "typeorm";

@Entity("versao")
export class  Versao {
    @PrimaryColumn()
    nome?: string
    @Column()
    versao?: string
    @Column()
    id?: string
}
